export const CSRF_TIMEOUT = 25 * 60 * 1000;
